<template>
  <v-main>
    <v-container fluid>
      <router-view :key="$route.path" />
    </v-container>
  </v-main>
</template>

<script>
  import DataUtils from '../../util/data'

  export default {
    name: 'DefaultView',
    data () {
      return {
        backPressedCount: 0,
      }
    },
    created () {
      if (DataUtils.isMobile()) {
        window.onBackPressed = this.onBackPressed
      }
    },
    beforeUpdate () {
      this.backPressedCount = 0
    },
    methods: {
      onBackPressed () {
        if (this.$route.name === 'PDFViewer') {
          this.$router.go(-1)
        } else if (this.backPressedCount === 0) {
          this.backPressedCount = 1
          window.Common.onBackPressed()
        } else if (this.backPressedCount === 1) {
          this.backPressedCount = 0
          window.Common.finishActivity()
        } else {
          window.Settings.setScreenBrightness(false)
          this.backPressedCount = 0
          this.$router.go(-1)
        }
      },
    },
  }
</script>
